import { render } from "./HospitalTop.vue?vue&type=template&id=1f0c64c7&ts=true"
import script from "./HospitalTop.vue?vue&type=script&lang=ts"
export * from "./HospitalTop.vue?vue&type=script&lang=ts"

import "./HospitalTop.vue?vue&type=style&index=0&id=1f0c64c7&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__